/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BigClock_Api_Models_ArrowPositionModel } from '../models/BigClock_Api_Models_ArrowPositionModel';
import type { BigClock_Api_Models_ClockMechanism_ManualMehMoveModel } from '../models/BigClock_Api_Models_ClockMechanism_ManualMehMoveModel';
import type { BigClock_Api_Models_ClockMechanism_StopTimerModel } from '../models/BigClock_Api_Models_ClockMechanism_StopTimerModel';
import type { BigClock_Api_Models_SaveAltitudeRequest } from '../models/BigClock_Api_Models_SaveAltitudeRequest';
import type { BigClock_Api_Models_StateModel } from '../models/BigClock_Api_Models_StateModel';
import type { BigClock_Application_Features_AltitudeCalculation_Dtos_AltitudeCalibrationDto } from '../models/BigClock_Application_Features_AltitudeCalculation_Dtos_AltitudeCalibrationDto';
import type { BigClock_Application_Features_AltitudeCalculation_Dtos_AltitudeResponseDto } from '../models/BigClock_Application_Features_AltitudeCalculation_Dtos_AltitudeResponseDto';
import type { BigClock_Application_Features_AltitudeCalculation_Dtos_PressureCalibrationHistoryDto } from '../models/BigClock_Application_Features_AltitudeCalculation_Dtos_PressureCalibrationHistoryDto';
import type { BigClock_Application_Queries_GetClockMechanismImpulseLive_GetClockMechanismImpulseLiveResponse } from '../models/BigClock_Application_Queries_GetClockMechanismImpulseLive_GetClockMechanismImpulseLiveResponse';
import type { BigClock_Application_Queries_GetClockMechanismParams_GetClockMechanismParamsResponse } from '../models/BigClock_Application_Queries_GetClockMechanismParams_GetClockMechanismParamsResponse';
import type { BigClock_Application_Queries_GetMechanismMeteoData_GetMechanismMeteoDataResponse } from '../models/BigClock_Application_Queries_GetMechanismMeteoData_GetMechanismMeteoDataResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MechanismService {
    /**
     * @param clockMechanismId
     * @returns BigClock_Application_Queries_GetClockMechanismParams_GetClockMechanismParamsResponse Success
     * @throws ApiError
     */
    public static getApiMechanismParams(
        clockMechanismId: string,
    ): CancelablePromise<BigClock_Application_Queries_GetClockMechanismParams_GetClockMechanismParamsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Mechanism/{clockMechanismId}/params',
            path: {
                'clockMechanismId': clockMechanismId,
            },
        });
    }
    /**
     * @param clockMechanismId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postApiMechanismArrows(
        clockMechanismId: string,
        requestBody?: BigClock_Api_Models_ArrowPositionModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Mechanism/{clockMechanismId}/arrows',
            path: {
                'clockMechanismId': clockMechanismId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param clockMechanismId
     * @returns BigClock_Application_Queries_GetClockMechanismImpulseLive_GetClockMechanismImpulseLiveResponse Success
     * @throws ApiError
     */
    public static getApiMechanismImpulseLive(
        clockMechanismId: string,
    ): CancelablePromise<BigClock_Application_Queries_GetClockMechanismImpulseLive_GetClockMechanismImpulseLiveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Mechanism/{clockMechanismId}/impulse/live',
            path: {
                'clockMechanismId': clockMechanismId,
            },
        });
    }
    /**
     * @param clockMechanismId
     * @returns BigClock_Application_Queries_GetMechanismMeteoData_GetMechanismMeteoDataResponse Success
     * @throws ApiError
     */
    public static getApiMechanismMeteo(
        clockMechanismId: string,
    ): CancelablePromise<BigClock_Application_Queries_GetMechanismMeteoData_GetMechanismMeteoDataResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Mechanism/{clockMechanismId}/meteo',
            path: {
                'clockMechanismId': clockMechanismId,
            },
        });
    }
    /**
     * @param clockMechanismId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postApiMechanismMovement(
        clockMechanismId: string,
        requestBody?: BigClock_Api_Models_StateModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Mechanism/{clockMechanismId}/movement',
            path: {
                'clockMechanismId': clockMechanismId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param clockMechanismId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postApiMechanismMovementManual(
        clockMechanismId: string,
        requestBody?: BigClock_Api_Models_ClockMechanism_ManualMehMoveModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Mechanism/{clockMechanismId}/movement/manual',
            path: {
                'clockMechanismId': clockMechanismId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param clockMechanismId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postApiMechanismMode(
        clockMechanismId: string,
        requestBody?: BigClock_Api_Models_StateModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Mechanism/{clockMechanismId}/mode',
            path: {
                'clockMechanismId': clockMechanismId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param clockMechanismId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postApiMechanismStopTimer(
        clockMechanismId: string,
        requestBody?: BigClock_Api_Models_ClockMechanism_StopTimerModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Mechanism/{clockMechanismId}/stop-timer',
            path: {
                'clockMechanismId': clockMechanismId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param clockMechanismId
     * @returns void
     * @throws ApiError
     */
    public static postApiMechanismSearch(
        clockMechanismId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Mechanism/{clockMechanismId}/search',
            path: {
                'clockMechanismId': clockMechanismId,
            },
        });
    }
    /**
     * @param clockMechanismId
     * @returns BigClock_Application_Features_AltitudeCalculation_Dtos_AltitudeResponseDto Success
     * @throws ApiError
     */
    public static postApiMechanismAltitudeCalculate(
        clockMechanismId: string,
    ): CancelablePromise<BigClock_Application_Features_AltitudeCalculation_Dtos_AltitudeResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Mechanism/{clockMechanismId}/altitude/calculate',
            path: {
                'clockMechanismId': clockMechanismId,
            },
            errors: {
                400: `Bad Request`,
                422: `Client Error`,
            },
        });
    }
    /**
     * @param clockMechanismId
     * @param requestBody
     * @returns BigClock_Application_Features_AltitudeCalculation_Dtos_AltitudeCalibrationDto Success
     * @throws ApiError
     */
    public static putApiMechanismAltitudeSave(
        clockMechanismId: string,
        requestBody?: BigClock_Api_Models_SaveAltitudeRequest,
    ): CancelablePromise<BigClock_Application_Features_AltitudeCalculation_Dtos_AltitudeCalibrationDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/Mechanism/{clockMechanismId}/altitude/save',
            path: {
                'clockMechanismId': clockMechanismId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @param clockMechanismId
     * @returns BigClock_Application_Features_AltitudeCalculation_Dtos_PressureCalibrationHistoryDto Success
     * @throws ApiError
     */
    public static getApiMechanismAltitudeCalibrations(
        clockMechanismId: string,
    ): CancelablePromise<BigClock_Application_Features_AltitudeCalculation_Dtos_PressureCalibrationHistoryDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Mechanism/{clockMechanismId}/altitude/calibrations',
            path: {
                'clockMechanismId': clockMechanismId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @param clockMechanismId
     * @returns BigClock_Application_Features_AltitudeCalculation_Dtos_PressureCalibrationHistoryDto Success
     * @throws ApiError
     */
    public static deleteApiMechanismAltitudeCalibrations(
        clockMechanismId: string,
    ): CancelablePromise<BigClock_Application_Features_AltitudeCalculation_Dtos_PressureCalibrationHistoryDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/Mechanism/{clockMechanismId}/altitude/calibrations',
            path: {
                'clockMechanismId': clockMechanismId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
